// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__GXpf7","inputWrap":"Table_inputWrap___X2Tt","col":"Table_col__2lfKN","bmiTooltip":"Table_bmiTooltip__g7JMV"};